import { BankTemplate } from "../bank-template/bank-template-bean";
import { PAMenuDesktop, PAMenuMobile } from "./pa-menu-meta";

export class PABankTemplateMenuUtility {

  public static readonly tmpMapMenuDesktop: Map<string, Function> = new Map<string, Function>();
  public static readonly tmpMapMenuDesktopTop: Map<string, Function> = new Map<string, Function>();
  public static readonly tmpMapMenuMobileView: Map<string, Function> = new Map<string, Function>();
  public static readonly tmpMapMenuMobileApp: Map<string, Function> = new Map<string, Function>();

  public static initTmpMapMenuDesktop() {
    this.tmpMapMenuDesktop.set(BankTemplate.NBD, this.replaceMenuDesktopNbd);
    this.tmpMapMenuDesktop.set(BankTemplate.FIRST_NATIONAL, this.replaceMenuDesktopFirstNational);
    this.tmpMapMenuDesktop.set(BankTemplate.GRENADA, this.replaceMenuDesktopGrenada);
    this.tmpMapMenuDesktop.set(BankTemplate.BOSVG, this.replaceMenuDesktopBosvg);
    this.tmpMapMenuDesktop.set(BankTemplate.BOSL, this.replaceMenuDesktopBosl);
    this.tmpMapMenuDesktop.set(BankTemplate.SKNA, this.replaceMenuDesktopSkna);
    this.tmpMapMenuDesktop.set(BankTemplate.ECAB, this.replaceMenuDesktopEcab);
    this.tmpMapMenuDesktop.set(BankTemplate.HERITAGE_DOM, this.replaceMenuDesktopHeritage);
    this.tmpMapMenuDesktop.set(BankTemplate.HERITAGE_INT, this.replaceMenuDesktopHeritage);
  }

  public static initTmpMapMenuDesktopTop() {
    this.tmpMapMenuDesktopTop.set(BankTemplate.NBD, this.replaceMenuDesktopTopNbd);
    this.tmpMapMenuDesktopTop.set(BankTemplate.FIRST_NATIONAL, this.replaceMenuDesktopTopFirstNational);
    this.tmpMapMenuDesktopTop.set(BankTemplate.GRENADA, this.replaceMenuDesktopTopGrenada);
    this.tmpMapMenuDesktopTop.set(BankTemplate.BOSVG, this.replaceMenuDesktopTopBosvg);
    this.tmpMapMenuDesktopTop.set(BankTemplate.BOSL, this.replaceMenuDesktopTopBosl);
    this.tmpMapMenuDesktopTop.set(BankTemplate.SKNA, this.replaceMenuDesktopTopSkna);
    this.tmpMapMenuDesktopTop.set(BankTemplate.ECAB, this.replaceMenuDesktopTopEcab);
    this.tmpMapMenuDesktopTop.set(BankTemplate.HERITAGE_DOM, this.replaceMenuDesktopTopHeritage);
    this.tmpMapMenuDesktopTop.set(BankTemplate.HERITAGE_INT, this.replaceMenuDesktopTopHeritage);
  }

  public static initTmpMapMenuMobileView() {
    this.tmpMapMenuMobileView.set(BankTemplate.NBD, this.replaceMenuMobileViewNbd);
    this.tmpMapMenuMobileView.set(BankTemplate.FIRST_NATIONAL, this.replaceMenuMobileViewFirstNational);
    this.tmpMapMenuMobileView.set(BankTemplate.GRENADA, this.replaceMenuMobileViewGrenada);
    this.tmpMapMenuMobileView.set(BankTemplate.BOSVG, this.replaceMenuMobileViewBosvg);
    this.tmpMapMenuMobileView.set(BankTemplate.BOSL, this.replaceMenuMobileViewBosl);
    this.tmpMapMenuMobileView.set(BankTemplate.SKNA, this.replaceMenuMobileViewSkna);
    this.tmpMapMenuMobileView.set(BankTemplate.ECAB, this.replaceMenuMobileViewEcab);
    this.tmpMapMenuMobileView.set(BankTemplate.HERITAGE_DOM, this.replaceMenuMobileViewHeritage);
    this.tmpMapMenuMobileView.set(BankTemplate.HERITAGE_INT, this.replaceMenuMobileViewHeritage);
  }

  public static initTmpMapMenuMobileApp() {
    this.tmpMapMenuMobileApp.set(BankTemplate.NBD, this.replaceMenuMobileNbd);
    this.tmpMapMenuMobileApp.set(BankTemplate.FIRST_NATIONAL, this.replaceMenuMobileFirstNational);
    this.tmpMapMenuMobileApp.set(BankTemplate.GRENADA, this.replaceMenuMobileGrenada);
    this.tmpMapMenuMobileApp.set(BankTemplate.BOSVG, this.replaceMenuMobileBosvg);
    this.tmpMapMenuMobileApp.set(BankTemplate.BOSL, this.replaceMenuMobileBosl);
    this.tmpMapMenuMobileApp.set(BankTemplate.SKNA, this.replaceMenuMobileSkna);
    this.tmpMapMenuMobileApp.set(BankTemplate.ECAB, this.replaceMenuMobileEcab);
    this.tmpMapMenuMobileApp.set(BankTemplate.HERITAGE_DOM, this.replaceMenuMobileHeritage);
    this.tmpMapMenuMobileApp.set(BankTemplate.HERITAGE_INT, this.replaceMenuMobileHeritage);
  }

  public static replaceMenuDesktopNbd(menu: PAMenuDesktop) { }
  public static replaceMenuDesktopTopNbd(menu: PAMenuDesktop) { }
  public static replaceMenuMobileViewNbd(menu: PAMenuMobile) { }
  public static replaceMenuMobileNbd(menu: PAMenuMobile) { }

  public static replaceMenuDesktopFirstNational(menu: PAMenuDesktop) { }
  public static replaceMenuDesktopTopFirstNational(menu: PAMenuDesktop) { }
  public static replaceMenuMobileViewFirstNational(menu: PAMenuMobile) { }
  public static replaceMenuMobileFirstNational(menu: PAMenuMobile) { }

  public static replaceMenuDesktopGrenada(menu: PAMenuDesktop) { }
  public static replaceMenuDesktopTopGrenada(menu: PAMenuDesktop) { }
  public static replaceMenuMobileViewGrenada(menu: PAMenuMobile) { }
  public static replaceMenuMobileGrenada(menu: PAMenuMobile) { }

  public static replaceMenuDesktopBosvg(menu: PAMenuDesktop) { }
  public static replaceMenuDesktopTopBosvg(menu: PAMenuDesktop) { }
  public static replaceMenuMobileViewBosvg(menu: PAMenuMobile) { }
  public static replaceMenuMobileBosvg(menu: PAMenuMobile) { }

  public static replaceMenuDesktopBosl(menu: PAMenuDesktop) { }
  public static replaceMenuDesktopTopBosl(menu: PAMenuDesktop) { }
  public static replaceMenuMobileViewBosl(menu: PAMenuMobile) { }
  public static replaceMenuMobileBosl(menu: PAMenuMobile) { }

  public static replaceMenuDesktopSkna(menu: PAMenuDesktop) { }
  public static replaceMenuDesktopTopSkna(menu: PAMenuDesktop) { }
  public static replaceMenuMobileViewSkna(menu: PAMenuMobile) { }
  public static replaceMenuMobileSkna(menu: PAMenuMobile) { }

  public static replaceMenuDesktopEcab(menu: PAMenuDesktop) { }
  public static replaceMenuDesktopTopEcab(menu: PAMenuDesktop) { }
  public static replaceMenuMobileViewEcab(menu: PAMenuMobile) { }
  public static replaceMenuMobileEcab(menu: PAMenuMobile) { }

  public static replaceMenuDesktopHeritage(menu: PAMenuDesktop) { }
  public static replaceMenuDesktopTopHeritage(menu: PAMenuDesktop) { }
  public static replaceMenuMobileViewHeritage(menu: PAMenuMobile) { }
  public static replaceMenuMobileHeritage(menu: PAMenuMobile) { }
}